import { createContext, useContext, useMemo } from "react";
const NavigationContext = createContext((to) => {
  if (typeof to !== "string") {
    throw new Error(`If you wish to support custom targets, implement your own navigation middleware.`);
  }
  return {
    href: to,
    navigate: (e) => {
      location.href = to;
      e?.preventDefault();
    },
    isActive: location.pathname === to
  };
});
const useNavigationLink = (to, href) => {
  const navigationContext = useContext(NavigationContext);
  return useMemo(() => {
    if (to === void 0) {
      return { href };
    }
    return navigationContext(to);
  }, [to, navigationContext, href]);
};
export {
  NavigationContext,
  useNavigationLink
};
//# sourceMappingURL=Navigation.js.map
